<template>
	<div class="pages">
		<navTop></navTop>
		<div class="box">
			<p>一般信息</p>
			<li>
				<span>1、ship name/IMO Number/Flag/Port Of registry（船名/IMO编号/船旗国/注册港）</span>
				<span>{{ data1.jz001 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz002 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz003" />
			</li>
			<li>
				<span>2、Call Sign（船舶呼号）</span>
				<span>{{ data1.jz004 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz005 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz006" />
			</li>
			<li>
				<span>3、GRT/NRT/DWT（总注册吨位/净注册吨位/载重公吨）</span>
				<span>{{ data1.jz007 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz008 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz009" />
			</li>
			<li>
				<span>4、LOA/Breadth/Depth（船长/船宽/型深）</span>
				<span>{{ data1.jz010 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz011 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz012" />
			</li>
			<li>
				<span>5、Port of loading（装货港）</span>
				<span>{{ data1.jz013 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz014 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz015" />
			</li>
			<li>
				<span>6、Port of discharging（卸货港）</span>
				<span>{{ data1.jz016 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz017 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz018" />
			</li>
			<li>
				<span>7、End of sea passage time（结束海上机动航行时间）</span>
				<span>{{ data1.jz019 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz020 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz021" />
			</li>
			<li>
				<span>8、all fast time（全部缆绳带好时间）</span>
				<span>{{ data1.jz022 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz023 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz024" />
			</li>
			<li>
				<span>9、commenced loading time（开始装货时间）</span>
				<span>{{ data1.jz025 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz026 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz027" />
			</li>
			<li>
				<span>10、completed loading time（结束装货时间）</span>
				<span>{{ data1.jz028 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz029 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz030" />
			</li>
			<li>
				<span>11、completed lashing time（绑扎结束时间）</span>
				<span>{{ data1.jz031 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz032 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz033" />
			</li>
			<li>
				<span>12、receivers（收货人公司名称）</span>
				<span>{{ data1.jz034 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz035 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz036" />
			</li>
			<li>
				<span>13、seller name（卖家公司名称）</span>
				<span>{{ data1.jz037 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz038 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz039" />
			</li>
			<li>
				<span>14、trader name（贸易商公司名称）</span>
				<span>{{ data1.jz040 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz041 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz042" />
			</li>
			<li>
				<span>15、Pieces /weight manifest（件数/吨位）</span>
				<span>{{ data1.jz043 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data1.jz044 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data1.jz045" />
			</li>
		</div>
		<div class="box">
			<p>装货前检验</p>
			<li>
				<span>16、Cargo stowage condition at openyard/warehouse/barge/truck(货物堆放在露天堆场/仓库/驳船/卡车)</span>
				<span>{{ data2.jz101 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz102 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz103" />
			</li>
			<li>
				<span>17、Dunnage condition at openyard/warehouse/barge/truck(货物堆放在露天堆场/仓库/驳船/卡车的垫木情况)</span>
				<span>{{ data2.jz104 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz105 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz106" />
			</li>
			<li>
				<span>18、Dunnage size at openyard/warehouse/barge/truck(货物堆放在露天堆场/仓库/驳船/卡车的垫木尺寸情况)</span>
				<span>{{ data2.jz107 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz108 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz109" />
			</li>
			<li>
				<span>19、Lashing condition at openyard/warehouse/barge/truck（货物堆放在露天堆场/仓库/驳船/卡车的绑扎情况）</span>
				<span>{{ data2.jz110 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz111 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz112" />
			</li>
			<li>
				<span>20、Insert number of pieces and quantity stated on B/L or cargo manifest/contract number（提单数量/吨位/合同号）</span>
				<span>{{ data2.jz113 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz114 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz115" />
			</li>
			<li>
				<span>21、Cargo coveraged by tarpaulin/plastic sheeting（货物是否被防水雨布/彩条布覆盖）</span>
				<span>{{ data2.jz116 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz117 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz118" />
			</li>
			<li>
				<span>22、Please insert grade of goods（货物钢种规格）</span>
				<span>{{ data2.jz119 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz120 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz121" />
			</li>
			<li>
				<span>23、Please write name of manufacturer/shipper（工厂/发货方名字）</span>
				<span>{{ data2.jz122 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz123 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz124" />
			</li>
			<li>
				<span>24、Please write specification number（规格说明）</span>
				<span>{{ data2.jz125 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz126 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz127" />
			</li>
			<li>
				<span>25、Please write mill's order number（订单号）</span>
				<span>{{ data2.jz128 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz129 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz130" />
			</li>
			<li>
				<span>26、Insert time when INSPECTION commenced（预检开始时间）</span>
				<span>{{ data2.jz131 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz132 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz133" />
			</li>
			<li>
				<span>27、Insert time when INSPECTION completed（预检结束时间）</span>
				<span>{{ data2.jz134 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz135 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz136" />
			</li>
			<li>
				<span>28、please Insert surveyor name（检验员名字）</span>
				<span>{{ data2.jz137 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz138 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz139" />
			</li>
			<li>
				<span>29、Please write the name of the surveyor that perform the join tly survey（联合检验检验员名字）</span>
				<span>{{ data2.jz140 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz141 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz142" />
			</li>

			<li>
				<span>30、write the location of the inspection: name of factory /Terminal and address（工厂名称/码头名字/地址）</span>
				<span>{{ data2.jz143 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz144 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz145" />
			</li>
			<li>
				<span>31、Letter of protest against Producer（出具给工厂的抗议）</span>
				<span v-if="data2.jz146 == 1">yes</span>
				<span v-if="data2.jz146 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz147 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz148" />
			</li>
			<li>
				<span>32、Letter of protest against Stevedores/Terminal（出具给绑扎公司/码头的抗议）</span>
				<span v-if="data2.jz149 == 1">yes</span>
				<span v-if="data2.jz149 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz150 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz151" />
			</li>
			<li>
				<span>33、Letter of protest against receiver（出具给收货人的抗议）</span>
				<span v-if="data2.jz152 == 1">yes</span>
				<span v-if="data2.jz152 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz153 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz154" />
			</li>
			<li>
				<span>34、Details of the shipping mark/lable（唛头/标签情况）</span>
				<span v-if="data2.jz155 == 1">yes</span>
				<span v-if="data2.jz155 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz156 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz157" />
			</li>
			<li>
				<span>35、Number of shipping/lable marks（唛头/标签数量）</span>
				<span v-if="data2.jz158 == 1">yes</span>
				<span v-if="data2.jz158 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz159 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz160" />
			</li>
			<li>
				<span>36、Details of the color mark（颜色标记情况）</span>
				<span v-if="data2.jz161 == 1">yes</span>
				<span v-if="data2.jz161 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz162 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz163" />
			</li>
			<li>
				<span>37、Number of color marks（颜色标记数量）</span>
				<span v-if="data2.jz164 == 1">yes</span>
				<span v-if="data2.jz164 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz165 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz166" />
			</li>
			<li>
				<span>38、Silver Nitrate test carried out randomly with negative result（随机硝酸银测试结果呈阴性）</span>
				<span v-if="data2.jz167 == 1">yes</span>
				<span v-if="data2.jz167 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz168 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz169" />
			</li>
			<li>
				<span>39、cargo condition (缺陷-生锈）</span>
				<span v-if="data2.jz170 == 1">yes</span>
				<span v-if="data2.jz170 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz171 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz172" />
			</li>
			<li>
				<span>40、cargo condition (缺陷-刮擦）</span>
				<span v-if="data2.jz173 == 1">yes</span>
				<span v-if="data2.jz173 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz174 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz175" />
			</li>
			<li>
				<span>41、cargo condition (缺陷-变形/弯曲）</span>
				<span v-if="data2.jz176 == 1">yes</span>
				<span v-if="data2.jz176 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz177 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz178" />
			</li>
			<li>
				<span>42、cargo condition (缺陷-油污）</span>
				<span v-if="data2.jz179 == 1">yes</span>
				<span v-if="data2.jz179 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz180 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz181" />
			</li>
			<li>
				<span>43、cargo condition (缺陷-绑带断）</span>
				<span v-if="data2.jz182 == 1">yes</span>
				<span v-if="data2.jz182 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz183 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz184" />
			</li>
			<li>
				<span>44、cargo condition (缺陷-褶皱破损）</span>
				<span v-if="data2.jz185 == 1">yes</span>
				<span v-if="data2.jz185 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz186 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz187" />
			</li>
			<li>
				<span>45、cargo condition (缺陷-水湿）</span>
				<span v-if="data2.jz188 == 1">yes</span>
				<span v-if="data2.jz188 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data2.jz189 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data2.jz190" />
			</li>
		</div>
		<div class="box">
			<p>船况监测</p>
			<li>
				<span>46、Did you find Rubber gaskets complete and without permanent indentations（橡胶垫片是否完整且无难以修复刻痕）</span>
				<span v-if="data3.jz201 == 1">yes</span>
				<span v-if="data3.jz201 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz202 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz203" />
			</li>
			<li>
				<span>47、Did you find coamings well and compression bars maintained（舱口围状态良好）</span>
				<span v-if="data3.jz204 == 1">yes</span>
				<span v-if="data3.jz204 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz205 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz206" />
			</li>
			<li>
				<span>48、Did you find Bilge pump without return valve or fully operative?（污水泵有无反水，以及阀门是否工作正常）</span>
				<span v-if="data3.jz207 == 1">yes</span>
				<span v-if="data3.jz207 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz208 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz209" />
			</li>
			<li>
				<span>49、Did you find cleats complete and workable?（压紧器是否正常）</span>
				<span v-if="data3.jz210 == 1">yes</span>
				<span v-if="data3.jz210 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz211 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz212" />
			</li>
			<li>
				<span>50、Did you find hatches watertight（舱盖水密情况）</span>
				<span v-if="data3.jz213 == 1">yes</span>
				<span v-if="data3.jz213 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz214 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz215" />
			</li>
			<li>
				<span>51、write the name of the last three previous cargo（最后三种货物名称）</span>
				<span>{{ data3.jz216 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz217 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz218" />
			</li>
			<li>
				<span>52、Did you find holds washed by fresh water prior to loading?（装货前是否用淡水洗舱）</span>
				<span v-if="data3.jz219 == 1">yes</span>
				<span v-if="data3.jz219 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz220 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz221" />
			</li>
			<li>
				<span>53、Are Man Hole Entrance in good conditions?（下舱人孔是否正常）</span>
				<span v-if="data3.jz222 == 1">yes</span>
				<span v-if="data3.jz222 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz223 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz224" />
			</li>
			<li>
				<span>54、 Draining Hole and draining pipes In good conditions（放残孔/管路是否正常）</span>
				<span v-if="data3.jz225 == 1">yes</span>
				<span v-if="data3.jz225 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz226 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz227" />
			</li>
			<li>
				<span>55、Chloride test delivered POSITIVE reaction（氯离子检测是否呈阳性）</span>
				<span>{{ data3.jz228 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz229 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz230" />
			</li>
			<li>
				<span>56、Show the type and the condition of the ventilation（通风孔情况）</span>
				<span>{{ data3.jz231 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz232 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz233" />
			</li>
			<li>
				<span>57、Show if the rubber gaskets, the coamings, the compression bars and the cleats are in good conditions</span>
				<span v-if="data3.jz234 == 1">yes</span>
				<span v-if="data3.jz234 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz235 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz236" />
			</li>
			<li>
				<span>58、Show if the holds are clean and dry and if the silver nitrate test gave negative reaction</span>
				<span v-if="data3.jz237 == 1">yes</span>
				<span v-if="data3.jz237 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data3.jz238 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data3.jz239" />
			</li>
		</div>
		<div class="box">
			<p>最终报告</p>
			<li>
				<span>59、write Average Temp /Moisture/Weather（平均温度/湿度/天气情况）</span>
				<span>{{ data4.jz301 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz302 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz303" />
			</li>
			<li>
				<span>60、write Number of cranes used/Crane grabs capacity（几台吊机工作/吊机负荷）</span>
				<span>{{ data4.jz304 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz305 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz306" />
			</li>
			<li>
				<span>61、Average loading/Discharging rate per hour（每小时装卸货速率）</span>
				<span>{{ data4.jz307 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz308 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz309" />
			</li>
			<li>
				<span>62、Did you find handling equipment suitable（装卸货设备是否合适）</span>
				<span v-if="data4.jz310 == 1">yes</span>
				<span v-if="data4.jz310 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz311 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz312" />
			</li>
			<li>
				<span>63、Cargo will be loading in which hold（货物装载至哪个舱）</span>
				<span>{{ data4.jz313 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz314 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz315" />
			</li>
			<li>
				<span>
					64、Specify the type of equipment used the crane (chains, steelslings, nylon belt（吊具选择为链条，钢丝绳，尼龙带可以做成选择式）
				</span>
				<span>{{ data4.jz316 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz317 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz318" />
			</li>
			<li>
				<span>
					65、Specify the type of protection used by the equipment in order to reduce mechanical damages during the
					handling（装卸过程中有无采取保护措施防止机械损伤）
				</span>
				<span v-if="data4.jz319 == 1">yes</span>
				<span v-if="data4.jz319 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz320 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz321" />
			</li>
			<li>
				<span>
					66、Specify what type of protection the forklift is equipped with to reduce the damages during the
					handling（使用叉车装卸过程中有无采取保护措施防止损伤）
				</span>
				<span v-if="data4.jz322 == 1">yes</span>
				<span v-if="data4.jz322 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz323 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz324" />
			</li>
			<li>
				<span>67、Did you find Mixed SAME cargo inside the hold that can caused cargo mixing(有没有和其他相同货物混装)</span>
				<span v-if="data4.jz325 == 1">yes</span>
				<span v-if="data4.jz325 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz326 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz327" />
			</li>
			<li>
				<span>
					68、Did you find Cargo stored near the water? If yes evaluate the risk of possible water Spraying AS WELL in the note
					(货物储存地有没有靠近水源，有没有可能对货物造成影响)
				</span>
				<span v-if="data4.jz328 == 1">yes</span>
				<span v-if="data4.jz328 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz329 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz330" />
			</li>
			<li>
				<span>69、Did you find other good stacked over our cargo(无货是否被压)</span>
				<span v-if="data4.jz331 == 1">yes</span>
				<span v-if="data4.jz331 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz332 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz333" />
			</li>
			<li>
				<span>70、Did you find traces of leakage inside the holds?(舱内是否有渗漏情况)</span>
				<span v-if="data4.jz334 == 1">yes</span>
				<span v-if="data4.jz334 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz335 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz336" />
			</li>
			<li>
				<span>71、Did you find traces of condensations inside the holds(舱内是否有冷凝情况)</span>
				<span v-if="data4.jz337 == 1">yes</span>
				<span v-if="data4.jz337 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz338 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz339" />
			</li>
			<li>
				<span>72、Did you find the cargo stacked OUTSIDE of the warehouse(货物是否堆放在室外)</span>
				<span v-if="data4.jz340 == 1">yes</span>
				<span v-if="data4.jz340 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz341 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz342" />
			</li>
			<li>
				<span>73、Did you find the cargo stacked alongside the vessel(货物是否堆放在船边)</span>
				<span v-if="data4.jz343 == 1">yes</span>
				<span v-if="data4.jz343 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz344 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz345" />
			</li>
			<li>
				<span>74、Did you fine rubber and wooden base alongside vessel satis factory?(船边的橡胶片/垫木是否合适)</span>
				<span v-if="data4.jz346 == 1">yes</span>
				<span v-if="data4.jz346 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz347 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz348" />
			</li>
			<li>
				<span>75、Is the cargo covered with plastic sheeting in the hold(舱内是否覆盖彩条布)</span>
				<span v-if="data4.jz349 == 1">yes</span>
				<span v-if="data4.jz349 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz350 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz351" />
			</li>
			<li>
				<span>76、Does the cargo loading /discharge took place during rainy weather?(是否雨中作业)</span>
				<span v-if="data4.jz352 == 1">yes</span>
				<span v-if="data4.jz352 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz353 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz354" />
			</li>
			<li>
				<span>
					77、Please write on the note all the equipments used for check the sizes the cargo inspected
					caliper/meter(是否通过游标卡尺/卷尺测量货物尺寸)
				</span>
				<span v-if="data4.jz355 == 1">yes</span>
				<span v-if="data4.jz355 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz356 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz357" />
			</li>
			<li>
				<span>78、Silver Nitrate test carried out randomly with negative result(随机硝酸银测试结果是否呈阴性)</span>
				<span v-if="data4.jz358 == 1">yes</span>
				<span v-if="data4.jz358 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz359 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz360" />
			</li>
			<li>
				<span>79、Material inspected +lashing +dunnaging before the hatches closing at the end of loading(绑扎材料/绑扎情况/垫木情况)</span>
				<span v-if="data4.jz361 == 1">yes</span>
				<span v-if="data4.jz361 == 0">no</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz362 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz363" />
			</li>
			<li>
				<span>80、is the hold, found i dry condition?(货舱是否干燥)</span>
				<span>{{ data4.jz364 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz365 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz366" />
			</li>
			<li>
				<span>81、Did you find cargo contained by oil or grease(是否发现油污)</span>
				<span>{{ data4.jz367 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz368 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz369" />
			</li>
			<li>
				<span>82、Did you find dock where the material has been placed found in dry condition(绑扎材料是否堆放在干燥区域)</span>
				<span>{{ data4.jz370 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz371 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz372" />
			</li>
			<li>
				<span>83、Show the type of the lashing used（wire rope/lashing bands/noly belt)(绑扎方式（钢丝绳，绑带，尼龙带）)</span>
				<span>{{ data4.jz373 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz374 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz375" />
			</li>
			<li>
				<span>84、Show the quantity and the quality of the wooden used(绑扎材料质量数量，垫木情况)</span>
				<span>{{ data4.jz376 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz377 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz378" />
			</li>
			<li>
				<span>85、Show if the cargo is properly stowed by use of the dunnaging on the tank top on sides /between tires(舱底)</span>
				<span>{{ data4.jz379 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz380 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz381" />
			</li>
			<li>
				<span>86、Show if the timber used is properly marked as per ISPM-15(垫木熏蒸情况)</span>
				<span>{{ data4.jz382 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz383 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz384" />
			</li>
			<li>
				<span>87、final stowage condition(最终积载图)</span>
				<span>{{ data4.jz385 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data4.jz386 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data4.jz387" />
			</li>
		</div>
		<div class="box">
			<p>货物信息</p>
			<li>
				<span>88、Shipper(发货方)</span>
				<span>{{ data5.jz401 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data5.jz402 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data5.jz403" />
			</li>
			<li>
				<span>89、B/L Number(提单号)</span>
				<span>{{ data5.jz404 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data5.jz405 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data5.jz406" />
			</li>
			<li>
				<span>90、Consignee(收货人)</span>
				<span>{{ data5.jz407 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data5.jz408 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data5.jz409" />
			</li>
			<li>
				<span>91、port of loading(装货港)</span>
				<span>{{ data5.jz410 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data5.jz411 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data5.jz412" />
			</li>
			<li>
				<span>92、port of discharging(卸货港)</span>
				<span>{{ data5.jz413 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data5.jz414 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data5.jz415" />
			</li>
			<li>
				<span>93、Commodity(货物名称)</span>
				<span>{{ data5.jz416 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data5.jz417 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data5.jz418" />
			</li>
			<li>
				<span>94、Weight of cargo(重量)</span>
				<span>{{ data5.jz419 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data5.jz420 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data5.jz421" />
			</li>
			<li>
				<span>95、Quantity(数量)</span>
				<span>{{ data5.jz422 }}</span>
			</li>
			<li>
				<span>备注（notes）：</span>
				<span>{{ data5.jz423 }}</span>
			</li>
			<li>
				<span>拍照：Take Pic</span>
				<img :src="data5.jz424" />
			</li>
		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
export default {
	name: 'workReport',
	components: {
		navTop
	},
	data() {
		return {
			height: '',
			id: '',
			data1: {},
			data2: {},
			data3: {},
			data4: {},
			data5: {}
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
			this.getSchedulejz();
		}
	},
	methods: {
		getSchedulejz() {
			let data = {
				id: this.id
			};
			this.$api.schedulejz(data).then(res => {
				console.log(res);
				if (res.result == 0) {
					this.data1 = res.data;
					this.data2 = res.data1;
					this.data3 = res.data2;
					this.data4 = res.data3;
					this.data5 = res.data4;
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #3E414A;
	.box {
		width: 100%;
		margin: 50px auto;
		border: 1px solid rgba(0, 255, 255, 0.25);
		border-radius: 10px;
		padding: 45px 154px 38px 56px;
		box-sizing: border-box;
		box-shadow: 0 0 300px 100px #043138 inset;
		p {
			color: #00fff0;
			font-size: 25px;
			line-height: 1em;
			text-align: center;
			font-weight: bold;
			margin-bottom: 10px;
		}
		li {
			display: flex;
			flex-direction: column;
			padding-bottom: 20px;
			box-sizing: border-box;
			span:nth-child(1) {
				color: #00fff0;
				font-size: 24px;
				line-height: 1em;
			}
			span:nth-child(2) {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			img {
				margin-top: 15px;
				display: block;
				width: 392px;
				height: 292px;
				border-radius: 10px;
			}
		}
	}
}
</style>
